<template>
    <Home fit="cover">
        <template #picture>
            <!-- background in babylonReady -->
        </template>
        <template #headline>Elektrische Ladesäulen einfach erklärt</template>
<!--        <template #subline>Babylon Subline und all die richtigen und wichtigen Texte</template>-->
        <template #text>
            <p>Elektrische Ladesäulen sind das Rückgrat der Elektromobilität. Sie versorgen Fahrzeuge sicher mit Strom, steuern den Ladevorgang digital und kommunizieren mit Auto und Stromnetz. Aufbau, Bedienung und Technik folgen klaren Standards – unabhängig davon, ob öffentlich oder privat geladen wird.</p>
        </template>
        <template #update>
<!--            19.01.2021-->
<!--            <br>Update: 29.01.2021-->
        </template>
    </Home>
</template>

<script>
    export default {
        name: 'schott',
        babylonState: {
            camera: {
                position: [.5 * Math.PI, .5 * Math.PI, 10],
                target: [-3, 0, 0],
            },
            zdfLogo: false
        },
        babylonReady: function ()
        {

        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emit('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {

            //opacity: 1;
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            //object-position: 50% 0%;
            //
            //@media (orientation: landscape) {
            //
            //    object-position: 0% 50%;
            //}
        }
    }

</style>
